import { locationProvider } from '../locationProvider.js';

/**
 * @param {string} [search] The search string to use. Defaults to the one provided by locationProvider
 * @returns {Object.<string, *>}
 */
export const getQueryParams = (search = undefined) => {
  search ??= locationProvider.search;

  return search.length
    ? search.slice(1)
      .split(/&/g)
      .map(v => v.split(/=/))
      .reduce(
        (obj, [key, value]) =>
          // if value is undefined, it means it's a boolean parameter, so we'll just put true
          Object.assign(obj, { [key]: value ?? true }),
        {}
      )
    : {}
};